"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7936,4913],{

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ currentSmallerThanFinalDate; },
/* harmony export */   "jB": function() { return /* binding */ fireHotjarEventScript; },
/* harmony export */   "no": function() { return /* binding */ fireHotjarEvents; }
/* harmony export */ });
/* unused harmony export fireHotjarEvent */
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64487);

var fireHotjarEventScript = function(eventName) {
    return '(function(w){\n        if(!hj) return;\n        w.hj("event","'.concat(eventName, '");\n    })(window)');
};
var fireHotjarEvent = function(eventName) {
    try {
        if (window.hj) {
            window.hj("event", eventName);
        }
    } catch (e) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb(e);
    }
};
// fires a list of events to Hotjar
var fireHotjarEvents = function(eventNames) {
    // have only unique values
    var uniqueEventNames = eventNames.filter(function(element, index, array) {
        return array.indexOf(element) === index;
    });
    // fire each event, so filtering can be fully customized on Hotjar side
    uniqueEventNames.forEach(function(uniqueEventName) {
        return fireHotjarEvent(uniqueEventName);
    });
};
var currentSmallerThanFinalDate = function(hotjarFinalDate) {
    var currentDate = new Date();
    var finalDate = new Date(hotjarFinalDate);
    return currentDate.getTime() <= finalDate.getTime();
};


/***/ }),

/***/ 39322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ universe_stars; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/math.js
var math = __webpack_require__(70942);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/universe-stars/universe-star/universe-star-component.scss.js

var StyledUniverseStarComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egtht0t0"
})('--twinkle-duration:"";--twinkle-delay:"";--star-size:"";position:absolute;background-image:url("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/star.svg");background-repeat:no-repeat;background-size:cover;width:var(--star-size);height:var(--star-size);border-radius:50%;animation:twinkle infinite alternate;animation-duration:var(--twinkle-duration);animation-delay:var(--twinkle-delay);will-change:transform;&.circle{background-image:unset;background:#fff;}@keyframes twinkle{from{transform:scale(0);}to{transform:scale(1.2);}}');

;// CONCATENATED MODULE: ./segments/desktop/core-components/universe-stars/universe-star/universe-star-component.js




var UniverseStarComponent = function(props) {
    var isCircle = props.isCircle, leftRange = props.leftRange, rightRange = props.rightRange, left = props.left, top = props.top, right = props.right;
    var getStarSize = function() {
        return "".concat((0,math/* randomNumber */.MH)(leftRange, rightRange), "px");
    };
    var getTwinkleDuration = function() {
        return "".concat(Math.ceil((0,math/* randomNumber */.MH)(1, 3)), "s");
    };
    var getTwinkleDelay = function() {
        return "".concat(Math.ceil((0,math/* randomNumber */.MH)(1, 8)), "s");
    };
    var getStyle = function() {
        return {
            left: left,
            top: top,
            right: right,
            "--star-size": getStarSize(),
            "--twinkle-duration": getTwinkleDuration(),
            "--twinkle-delay": getTwinkleDelay()
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUniverseStarComponent, {
        className: classnames_default()("universe-star", {
            circle: isCircle
        }),
        style: getStyle()
    });
};
/* harmony default export */ var universe_star_component = (UniverseStarComponent);

;// CONCATENATED MODULE: ./segments/desktop/core-components/universe-stars/default-props.js
/* harmony default export */ var default_props = ({
    stars: []
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/universe-stars/universe-stars.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var UniverseStars = function(props) {
    var stars = props.stars;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: stars.map(function(star, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(universe_star_component, _object_spread({
                leftRange: 3,
                rightRange: 10
            }, star), "star-".concat(index));
        })
    });
};
/* harmony default export */ var universe_stars = (UniverseStars);
UniverseStars.defaultProps = default_props;


/***/ }),

/***/ 74913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ square_tags_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/square-tags.js + 4 modules
var square_tags = __webpack_require__(76416);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component.scss.js

var StyledSquareTagsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erc6e3p0"
})();

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/default-props.js
var default_props = __webpack_require__(62414);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/default-props.js

/* harmony default export */ var square_tags_grid_default_props = (default_props/* default */.Z);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var SquareTagsGridComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSquareTagsGridComponent, {
        className: "square-tags-grid-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(square_tags/* default */.Z, _object_spread({}, props))
    });
};
SquareTagsGridComponent.defaultProps = square_tags_grid_default_props;
/* harmony default export */ var square_tags_grid_component = (SquareTagsGridComponent);


/***/ }),

/***/ 96515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ monday_universe_homepage_first_fold_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./utils/math.js
var math = __webpack_require__(70942);
// EXTERNAL MODULE: ./segments/desktop/core-components/universe-stars/universe-stars.js + 3 modules
var universe_stars = __webpack_require__(39322);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component.js + 2 modules
var square_tags_grid_component = __webpack_require__(74913);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/palette-schemes.js
var palette_schemes = __webpack_require__(81122);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/default-props.js
var default_props = __webpack_require__(62414);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/default-props.js



var defaultLine = {
    top: 270,
    startLeft: 630,
    endLeft: 735
};
/* harmony default export */ var monday_universe_homepage_first_fold_default_props = ({
    fullParagraph: {
        title: "A platform built for a new way of working",
        body: "What would you like to manage with monday.com Work OS?"
    },
    subTitle: {},
    subTitleAdvancedConfig: {
        titleSize: sizes.XS
    },
    clusters: default_props/* starsClusters */.F,
    lines: [
        {
            start: {
                top: "".concat(defaultLine.top),
                left: "".concat(defaultLine.startLeft)
            },
            end: {
                top: "".concat(defaultLine.top),
                left: "".concat(defaultLine.endLeft)
            }
        }
    ],
    buttonConfig: {
        buttonColor: color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME
    },
    fullParagraphAdvancedConfig: {
        titleSize: sizes.XL,
        textSize: sizes.LG,
        titleWidth: "800px",
        spaceFromParagraph: "32px",
        buttonTopMargin: "196px"
    },
    paddingTop: "64px"
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/monday-universe-homepage-first-fold-component.scss.js


var StyledMondayUniverseHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eab5fg90"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;height:600px;display:flex;flex-direction:column;position:relative;align-items:center;justify-content:center;.stars-canvas{position:absolute;height:100%;width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;.comet-line{position:absolute;height:1px;background:linear-gradient(90deg,transparent,#fff,transparent);&.underline{background:linear-gradient(90deg,transparent,#fff);}}}.paragraph-wrapper{.title-wrapper{margin-left:auto;margin-right:auto;.universe-title{padding-bottom:12px;font-weight:400;}}.sub-title{text-align:center;margin-top:40px;font-weight:bold;}}&.universe-theme{.paragraph-wrapper{.title-wrapper{.universe-title{background:linear-gradient(360deg,#ffffff 53.95%,#0b0b4a 207.37%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/stars-clusters-config.js
var stars = [
    // top left
    {
        top: 160,
        left: -129
    },
    {
        top: 227,
        left: -106
    },
    {
        top: 20,
        left: -20
    },
    {
        top: 128,
        left: 220
    },
    {
        top: 73,
        left: 315
    },
    {
        top: 218,
        left: 12
    },
    // middle
    {
        top: 50,
        left: 510
    },
    {
        top: 35,
        left: 855
    },
    {
        top: 449,
        left: 424
    },
    {
        top: 515,
        left: 387
    },
    // near signup
    {
        top: 495,
        left: 946
    },
    {
        top: 487,
        left: 985
    },
    {
        top: 480,
        left: 976
    },
    // right
    {
        top: 24,
        left: 1036
    },
    {
        top: 59,
        left: 1138
    },
    {
        top: 86,
        left: 1087
    },
    {
        top: 380,
        left: 1378
    },
    {
        top: 202,
        left: 1522
    }
];

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/monday-universe-homepage-first-fold-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var Stars = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(universe_stars/* default */.Z, {
        stars: stars
    });
});
var MondayUniverseHomepageFirstFoldComponent = function(props) {
    var fullParagraph = props.fullParagraph, subTitle = props.subTitle, subTitleAdvancedConfig = props.subTitleAdvancedConfig, fullParagraphAdvancedConfig = props.fullParagraphAdvancedConfig, buttonConfig = props.buttonConfig, clusters = props.clusters, theme = props.theme, abTests = props.abTests, translate = props.translate, tagsWidth = props.tagsWidth, pallet = props.pallet, squareTagsMarginTop = props.squareTagsMarginTop, showBorderInLightTheme = props.showBorderInLightTheme, randomizeTags = props.randomizeTags;
    var paletteScheme = (0,react.useMemo)(function() {
        return palette_schemes/* default */.Z[pallet] || {};
    }, [
        pallet
    ]);
    var renderLines = function() {
        var lines = props.lines;
        return lines.map(function(line, index) {
            var _line_start, _line_start1, _line_end, _line_end1;
            var lineStart = {
                top: parseInt(line === null || line === void 0 ? void 0 : (_line_start = line.start) === null || _line_start === void 0 ? void 0 : _line_start.top),
                left: parseInt(line === null || line === void 0 ? void 0 : (_line_start1 = line.start) === null || _line_start1 === void 0 ? void 0 : _line_start1.left)
            };
            var lineEnd = {
                top: parseInt(line === null || line === void 0 ? void 0 : (_line_end = line.end) === null || _line_end === void 0 ? void 0 : _line_end.top),
                left: parseInt(line === null || line === void 0 ? void 0 : (_line_end1 = line.end) === null || _line_end1 === void 0 ? void 0 : _line_end1.left)
            };
            if (!Number.isInteger(lineStart.top) || !Number.isInteger(lineStart.left) || !Number.isInteger(lineEnd.top) || !Number.isInteger(lineEnd.left)) {
                return null;
            }
            var angle = Math.atan2(lineEnd.top - lineStart.top, lineEnd.left - lineStart.left) * 180 / Math.PI;
            var distance = (0,math/* lineDistance */.sI)(lineStart.left, lineStart.top, lineEnd.left, lineEnd.top);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("comet-line", {
                    underline: true
                }),
                style: _object_spread({
                    transform: "rotate(".concat(angle, "deg)"),
                    width: distance
                }, lineStart)
            }, "comet-".concat(index));
        });
    };
    var isUniverseTheme = theme === segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7;
    var squareTagsProps = {
        tagsWidth: tagsWidth,
        buttonConfig: buttonConfig,
        clusters: clusters,
        theme: theme,
        marginTop: squareTagsMarginTop,
        showBorderInLightTheme: showBorderInLightTheme,
        randomizeTags: randomizeTags
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMondayUniverseHomepageFirstFoldComponent, {
        className: classnames_default()("monday-universe-homepage-first-fold-component", {
            "selectable-clusters": true,
            "universe-theme": isUniverseTheme
        }),
        children: [
            isUniverseTheme && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "stars-canvas",
                children: [
                    renderLines(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("paragraph-wrapper"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread_props(_object_spread({}, fullParagraphAdvancedConfig, fullParagraph), {
                        topic: {},
                        textAlign: align_types.ALIGN_TYPES.CENTER,
                        titleClassName: "universe-title"
                    })),
                    (subTitle === null || subTitle === void 0 ? void 0 : subTitle.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, _object_spread_props(_object_spread({}, subTitle, subTitleAdvancedConfig), {
                        titleClassName: "sub-title"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(square_tags_grid_component["default"], _object_spread({
                palette: paletteScheme
            }, squareTagsProps))
        ]
    });
};
var MondayUniverseHomepageFirstFoldComponentWithAbTests = (0,ab_tests_context/* withAbTests */.k)(MondayUniverseHomepageFirstFoldComponent);
MondayUniverseHomepageFirstFoldComponentWithAbTests.defaultProps = monday_universe_homepage_first_fold_default_props;
/* harmony default export */ var monday_universe_homepage_first_fold_component = (MondayUniverseHomepageFirstFoldComponentWithAbTests);


/***/ })

}]);